import { render, staticRenderFns } from "./AdminFoods.vue?vue&type=template&id=be9ca776&scoped=true&"
import script from "./AdminFoods.vue?vue&type=script&lang=js&"
export * from "./AdminFoods.vue?vue&type=script&lang=js&"
import style0 from "./AdminFoods.vue?vue&type=style&index=0&id=be9ca776&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9ca776",
  null
  
)

export default component.exports